import {
  Pipe,
  PipeTransform
} from '@angular/core';
import {PolishDeclination} from '../services/polish-declination';

@Pipe({name: 'monthFormat'})
export class MonthForm implements PipeTransform {
  transform(_monthNumber: number): string {
    const declinations: Array<string> = [
      'miesiąc',
      'miesiące',
      'miesięcy'
    ];

    return PolishDeclination(_monthNumber, declinations);
  }
}
